import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import ModalPortal from '../../../../components/modal-portal';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import InventoryLevelsTable from './inventory-levels-table';
import { emptyObject } from 'ui-components/default-props/empty';
import style from './style.module.less';
import messages from './messages';
import { TruncatedText } from 'ui-components/components/truncated-text';

const InventoryLevelsModal = ({ aggregateInventoryCounts, name, onCloseModal }) => {
  const { availableQuantity, excludedQuantity, connectionCounts } = aggregateInventoryCounts;
  const quantityToDisplay = useMemo(() => {
    return availableQuantity - excludedQuantity;
  }, [availableQuantity, excludedQuantity]);
  const groupedCounts = useMemo(() => {
    return connectionCounts.reduce((agg, count) => {
      if (!Object.keys(agg).some((fn) => fn === count.connectionType)) {
        return {
          ...agg,
          [count.connectionType]: [count],
        };
      }
      return {
        ...agg,
        [count.connectionType]: [...agg[count.connectionType], count],
      };
    }, emptyObject);
  }, [connectionCounts]);

  return (
    <ModalPortal containerId='reprocess-automation-rule-modal' onClose={onCloseModal}>
      <Modal size='medium'>
        <ModalHeader closeModal={onCloseModal}>
          <FormattedMessage {...messages.header} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <div className={style['body-description']}>
            <div className={style.total}>
              <div className={style.quantity}>
                <FormattedNumber value={quantityToDisplay} />
              </div>
              <div className={style.available}>available</div>
            </div>
            <div className={style['name-description']}>
              <TruncatedText className={style.name} value={name} />
              <div className={style.description}>
                <FormattedMessage
                  {...messages.description}
                  values={{
                    link: (chunks) => <Link to='/settings/inventorysync'>{chunks}</Link>,
                  }}
                />
              </div>
            </div>
          </div>
          <InventoryLevelsTable groupedConnectionCounts={groupedCounts} />
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
};

export default InventoryLevelsModal;

InventoryLevelsModal.propTypes = {
  aggregateInventoryCounts: PropTypes.shape({
    availableQuantity: PropTypes.number,
    committedQuantity: PropTypes.number,
    excludedQuantity: PropTypes.number,
    hasValidInventory: PropTypes.bool,
    connectionCounts: PropTypes.arrayOf(
      PropTypes.shape({
        availableQuantity: PropTypes.number,
        isConnectionIncluded: PropTypes.bool,
        connectionStatus: PropTypes.string,
        connectionType: PropTypes.string,
        onhandQuantity: PropTypes.number,
      }),
    ),
  }),
  name: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};
